module.exports = __webpack_public_path__ + "static/media/photo-slider-icon.0d70709f.svg";